import { takeEvery, takeLatest } from 'redux-saga/effects';
import { AUTHORIZED_MODULE, SETTINGS_MODULE } from '../../../configs/moduleNames';
import {
  CREATE_ROLE,
  CREATE_USER,
  DELETE_EXPORT,
  DELETE_ROLE,
  DELETE_USER,
  LOAD_EXPORT,
  LOAD_PRESETS,
  LOAD_ROLE_LIST,
  LOAD_USER_LIST,
  LOAD_USER_ACTION,
  SAVE_EXPORT,
  SAVE_PRESET,
  SAVE_ROLE,
  SAVE_USER,
  SET_COMPASS,
  SET_GPS_MOD,
  LOAD_WANTED_LIST,
  ADD_LPN_TO_WANTED,
  DELETE_FROM_WANTED,
  IMPORT_LPN_FILE,
  CREATE_CAMERA,
  SAVE_CAMERA,
  DELETE_CAMERA,
  LOAD_CAMERAS,
  SET_PTZ,
  IMPORT_WHITE_LIST,
  DELETE_FROM_WHITE_LIST,
  ADD_TO_WHITE_LIST,
  LOAD_WHITE_LIST,
  LOAD_VIOLATION_LIST,
  ADD_TO_VIOLATION_LIST,
  DELETE_FROM_VIOLATION_LIST,
  IMPORT_VIOLATION_LIST,
  CREATE_PRESET,
  DELETE_PRESET,
  LOAD_PRESETS_COLLAGE,
  CALIBRATE_CAMERA,
  GET_DEFAULT_COLLAGE,
  NODE_EVENT,
  LOAD_DATE_SETTINGS,
  SAVE_DATE_SETTINGS,
  LOAD_ARCHIVE_SETTINGS,
  SAVE_ARCHIVE_SETTINGS,
  LOAD_ANALYSTS_SETTINGS,
  SAVE_ANALYSTS_SETTINGS,
  LOAD_DATE_STATUS,
  LOAD_GENERAL_SETTINGS,
  SAVE_GENERAL_SETTINGS,
  UPDATE_EXPORT,
} from '../actions';
import { AUTHORIZED_CHECK } from '../../Authorized/actions';
import { SUCCESSFUL } from '../../../configs/actionNames';

import setCompass from './setCompass';
import setGpsMod from './setGpsMod';
import loadPresets from './loadPresets';
import savePresets from './savePresets';
import loadExport from './loadExport';
import saveExport from './saveExport';
import deleteExport from './deleteExport';
import loadRoleList from './loadRoleList';
import saveRole from './saveRole';
import deleteRole from './deleteRole';
import loadUserList from './loadUserList';
import saveUser from './saveUser';
import deleteUser from './deleteUser';
import createRole from './createRole';
import createUser from './createUser';
import loadWantedList from './loadWantedList';
import addLPNToWanted from './addLPNToWanted';
import deleteFromWanted from './deleteFromWanted';
import importLPNFile from './importLPNFile';
import loadCameras from './loadCameras';
import saveCamera from './saveCamera';
import createCamera from './createCamera';
import deleteCamera from './deleteCamera';
import setPTZ from './setPTZ';
import loadWhiteList from './loadWhiteList';
import addToWhiteList from './addToWhiteList';
import deleteFromWhiteList from './deleteFromWhiteList';
import importWhiteList from './importWhiteList';
import importViolationList from './importViolationList';
import deleteFromViolationList from './deleteFromViolationList';
import addToViolationList from './addToViolationList';
import loadViolationList from './loadViolationList';
import createPreset from './createPreset';
import deletePreset from './deletePreset';
import loadPresetsCollage from './loadPresetsCollage';
import loadUserAction from './loadUserAction';
import calibrateCamera from './calibrateCamera';
import getDefaultCollage from './getDefaultCollage';
import nodeEvent from './nodeEvent';
import loadDateSettings from './loadDateSettings';
import saveDateSettings from './saveDateSettings';
import loadArchiveSettings from './loadArchiveSettings';
import saveArchiveSettings from './saveArchiveSettings';
import loadAnalystsSettings from './loadAnalystsSettings';
import saveAnalystsSettings from './saveAnalystsSettings';
import loadDateStatus from './loadDateStatus';
import loadGeneralSettings from './loadGeneralSettings';
import saveGeneralSettings from './saveGeneralSettings';
import updateExport from './updateExport';

export default function* watchDashboard() {
  yield takeEvery(SETTINGS_MODULE + SET_COMPASS, setCompass);
  yield takeEvery(SETTINGS_MODULE + SET_GPS_MOD, setGpsMod);
  yield takeEvery(SETTINGS_MODULE + LOAD_PRESETS, loadPresets);
  yield takeEvery(SETTINGS_MODULE + SAVE_PRESET, savePresets);
  yield takeEvery(SETTINGS_MODULE + CREATE_PRESET, createPreset);
  yield takeEvery(SETTINGS_MODULE + DELETE_PRESET, deletePreset);
  yield takeLatest(SETTINGS_MODULE + LOAD_PRESETS_COLLAGE, loadPresetsCollage);
  yield takeEvery(SETTINGS_MODULE + LOAD_EXPORT, loadExport);
  yield takeEvery(SETTINGS_MODULE + SAVE_EXPORT, saveExport);
  yield takeEvery(SETTINGS_MODULE + DELETE_EXPORT, deleteExport);
  yield takeEvery(SETTINGS_MODULE + LOAD_ROLE_LIST, loadRoleList);
  yield takeEvery(SETTINGS_MODULE + SAVE_ROLE, saveRole);
  yield takeEvery(SETTINGS_MODULE + DELETE_ROLE, deleteRole);
  yield takeEvery(SETTINGS_MODULE + LOAD_USER_LIST, loadUserList);
  yield takeEvery(SETTINGS_MODULE + SAVE_USER, saveUser);
  yield takeEvery(SETTINGS_MODULE + CREATE_USER, createUser);
  yield takeEvery(SETTINGS_MODULE + DELETE_USER, deleteUser);
  yield takeEvery(SETTINGS_MODULE + CREATE_ROLE, createRole);
  yield takeEvery(SETTINGS_MODULE + LOAD_WANTED_LIST, loadWantedList);
  yield takeEvery(SETTINGS_MODULE + ADD_LPN_TO_WANTED, addLPNToWanted);
  yield takeEvery(SETTINGS_MODULE + DELETE_FROM_WANTED, deleteFromWanted);
  yield takeEvery(SETTINGS_MODULE + IMPORT_LPN_FILE, importLPNFile);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL, loadCameras);
  yield takeEvery(SETTINGS_MODULE + LOAD_CAMERAS, loadCameras);
  yield takeEvery(SETTINGS_MODULE + CREATE_CAMERA, createCamera);
  yield takeEvery(SETTINGS_MODULE + SAVE_CAMERA, saveCamera);
  yield takeEvery(SETTINGS_MODULE + DELETE_CAMERA, deleteCamera);
  yield takeLatest(SETTINGS_MODULE + SET_PTZ, setPTZ);
  yield takeEvery(SETTINGS_MODULE + LOAD_WHITE_LIST, loadWhiteList);
  yield takeEvery(SETTINGS_MODULE + ADD_TO_WHITE_LIST, addToWhiteList);
  yield takeEvery(SETTINGS_MODULE + DELETE_FROM_WHITE_LIST, deleteFromWhiteList);
  yield takeEvery(SETTINGS_MODULE + IMPORT_WHITE_LIST, importWhiteList);
  yield takeEvery(SETTINGS_MODULE + LOAD_VIOLATION_LIST, loadViolationList);
  yield takeEvery(SETTINGS_MODULE + ADD_TO_VIOLATION_LIST, addToViolationList);
  yield takeEvery(SETTINGS_MODULE + DELETE_FROM_VIOLATION_LIST, deleteFromViolationList);
  yield takeEvery(SETTINGS_MODULE + IMPORT_VIOLATION_LIST, importViolationList);
  yield takeEvery(SETTINGS_MODULE + LOAD_USER_ACTION, loadUserAction);
  yield takeEvery(SETTINGS_MODULE + CALIBRATE_CAMERA, calibrateCamera);
  yield takeEvery(SETTINGS_MODULE + GET_DEFAULT_COLLAGE, getDefaultCollage);
  yield takeEvery(SETTINGS_MODULE + NODE_EVENT, nodeEvent);
  yield takeEvery(SETTINGS_MODULE + LOAD_DATE_SETTINGS, loadDateSettings);
  yield takeEvery(SETTINGS_MODULE + LOAD_DATE_STATUS, loadDateStatus);
  yield takeEvery(SETTINGS_MODULE + SAVE_DATE_SETTINGS, saveDateSettings);
  yield takeEvery(SETTINGS_MODULE + LOAD_ARCHIVE_SETTINGS, loadArchiveSettings);
  yield takeEvery(SETTINGS_MODULE + SAVE_ARCHIVE_SETTINGS, saveArchiveSettings);
  yield takeEvery(SETTINGS_MODULE + LOAD_ANALYSTS_SETTINGS, loadAnalystsSettings);
  yield takeEvery(SETTINGS_MODULE + SAVE_ANALYSTS_SETTINGS, saveAnalystsSettings);
  yield takeEvery(SETTINGS_MODULE + LOAD_GENERAL_SETTINGS, loadGeneralSettings);
  yield takeEvery(SETTINGS_MODULE + SAVE_GENERAL_SETTINGS, saveGeneralSettings);
  yield takeEvery(SETTINGS_MODULE + UPDATE_EXPORT, updateExport);
}
